import Vue from 'vue';
import Router from 'vue-router';

// import Sign from "./modules/Sign";
import Home from './modules/Home';
import store from '../store'
import config from "@/config";
import { login } from '../utils/index'

Vue.use(Router);

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const router = new Router({
	mode: "history",
	base: 'user-query',
	routes: [
		// 首页
		Home
	],
});

function getQueryString(name) {
	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var k = document.cookie.match(reg);
  // console.log('cookie'+ k);
  // alert(k)
  if(k != null){
    return unescape(k[2])
  }else{
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
  }
	
	return null;
}

// 路由守卫
router.beforeEach((t, f, n) => {
  console.log("路由守卫",t,f)
  /* 路由发生变化修改页面title */
  if (t.meta.title) {
    document.title = t.meta.title
  }
  // console.log("getQueryString('token')", store.getters.token, getQueryString('token'))
  // let Ttoken =store.getters.token
    // let userInfo = JSON.parse(
    //   decodeURIComponent(escape(window.atob(Ttoken)))
    // );
    // console.log('userInfo',userInfo)
    //debugger
  // if (t.meta.title !== '新生学号查询'){
  //   // var token = getQueryString('userToken');
  //   if( store.state.user.token == null ){
  //   	login()
  //   }
  // }

  if (getQueryString('userToken')) {
    var token = getQueryString('userToken');
    store.commit('SET_TOKEN', token)
  }else if (!store.getters.token && getQueryString('token')) {
    var token = getQueryString('token');
    store.commit('SET_TOKEN', token)
  }
  if ( f.name == 'ApplicationService') {
          f.meta.keepAlive = true;
       }else {
          f.meta.keepAlive = false;
       }
  n()
})

// 路由守卫
// router.beforeEach((to, from, next) => {
//   // to 404
//   if (to.path === '/' && to.name !== 'Home') next('*');
//   next();
// });

export default router;
